import { render, staticRenderFns } from "./BudgetSettings.vue?vue&type=template&id=afc83434&scoped=true&"
import script from "./BudgetSettings.vue?vue&type=script&setup=true&lang=js&"
export * from "./BudgetSettings.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BudgetSettings.vue?vue&type=style&index=0&id=afc83434&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc83434",
  null
  
)

export default component.exports